<template>
  <div class="page">
    <!-- header -->
    <header-bar :selected="selected" :cityName="cityName" @getCityId="getCityId"></header-bar>
    <!-- container -->
    <div class="container">
      <div class="user-nav">
        <h1>个人中心</h1>
        <ul class="menu-list">
          <li :class="['menu-item', navCurrent==0?'active':'']"><a class="subMLink" @click="goPage(0)">我的订单</a></li>
          <li :class="['menu-item', navCurrent==1?'active':'']"><a class="subMLink" @click="goPage(1)">我的卡包</a></li>
          <li :class="['menu-item', navCurrent==2?'active':'']"><a class="subMLink" @click="goPage(2)">我的消息</a></li>
          <li :class="['menu-item', navCurrent==3?'active':'']"><a class="subMLink" @click="goPage(3)">我的公告</a></li>
          <li :class="['menu-item', navCurrent==4?'active':'']"><a class="subMLink" @click="goPage(4)">基本信息</a></li>
        </ul>
      </div>
      <!-- ============================我的订单============================ -->
      <div class="main" v-if="navCurrent==0">
        <div class="title">我的订单</div>
        <div class="order-box" v-for="(item, index) in dataList" :key="index">
          <div class="order-header">
            <span class="order-date">{{item.createDate}}</span>
            <span class="order-id">看购订单号:{{item.orderId}}</span>
            <!-- <span class="del-order"></span> -->
          </div>
          <div class="order-body">
            <div class="poster">
              <img :src="item.photo">
            </div>
            <div class="order-content">
              <div class="movie-name">《{{item.filmName}}》</div>
              <div class="cinema-name">{{item.cinemaName}}</div>
              <div class="hall-ticket">
                <span>{{item.hallName}}</span>
                <span>{{item.seat}}</span>
              </div>
              <div class="show-time">{{item.showTime}}</div>
            </div>
            <div class="order-price">{{item.orderPrice}}</div>
            <div class="order-status">
              <span class="zhuangtai" v-if="item.status == '0'">待支付</span>
              <span class="zhuangtai" v-if="item.status == '1'">已支付</span>
              <span class="zhuangtai" v-if="item.status == '2'">交易完成</span>
              <span class="zhuangtai" v-if="item.status == '3'">确认座位失败</span>
              <span class="zhuangtai" v-if="item.status == '4'">等待退款</span>
              <span class="zhuangtai" v-if="item.status == '8'">已退款</span>
              <span class="zhuangtai" v-if="item.status == '9'">订单取消</span>
            </div>
            <div class="actions">
              <p class="btn" v-if="item.status == '0'" @click="toConfirmOrder(item.orderId)">付款</p>
              <p class="link" @click="toOrderDetail(item.orderId)">查看详情</p>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :page-size="pageSize"
            :current-page.sync="pageNum"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- ============================我的卡包============================ -->
      <div class="main" style="min-height: 640px;" v-if="navCurrent==1">
        <div class="title">我的卡包</div>
        <iframe :src="myCardBagUrl" frameborder="0" scrolling="auto" style="width: 100%;height: 80%;"></iframe>
      </div>
      <!-- ============================我的消息============================ -->
      <div class="main" v-if="navCurrent==2">
        <div class="title">我的消息</div>
        <template v-if="newsList.length>0">
          <div class="order-box" v-for="(item, index) in newsList">
            <div class="order-header">
              <span class="order-date">{{item.send_time}}</span>
            </div>
            <div class="order-body" style="justify-content: space-between;padding-right:20px;">
              <div class="order-content">{{item.content}}</div>
              <div class="actions">
                <p class="link" @click="toNewsDialog(index)">查看二维码</p>
              </div>
            </div>
          </div>
        </template>
        <!-- 点击打开dialog -->
        <el-dialog
          title="二维码"
          :visible.sync="newsDialogVisible"
          width="25%" v-if="newsList[newsCurrentIndex]">
          <vue-qr class="er_code" 
            :margin="0"
            :auto-color="true"
            :dot-scale="1"
            :text="newsList[newsCurrentIndex].qrCode"/>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="newsDialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            background
            @current-change="handleCurrentChange2"
            layout="total,prev, pager, next"
            :page-size="newPageSize"
            :current-page.sync="newPageNum"
            :total="newTotal">
          </el-pagination>
        </div>
      </div>
      <!-- ============================我的公告============================ -->
      <div class="main" v-if="navCurrent==3">
        <div class="title">我的公告</div>
        <div class="order-box" v-for="(item, index) in noticeList">
          <div class="order-header">
            <span class="order-date">{{item.title}}</span>
          </div>
          <div class="order-body" style="justify-content: space-between;padding-right:20px;">
            <div class="order-content">{{item.content}}</div>
            <div class="actions">
              <p class="link">{{item.modifydate}}</p>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            background
            @current-change="handleCurrentChange3"
            layout="total,prev, pager, next"
            :page-size="noticePageSize"
            :current-page.sync="noticePageNum"
            :total="noticeTotal">
          </el-pagination>
        </div>
      </div>
      <!-- ============================基本信息============================ -->
      <div class="main" style="min-height: 640px;" v-if="navCurrent==4">
        <div class="title">基本信息</div>
        <iframe :src="webinfoUrl" frameborder="0" scrolling="auto" style="width: 100%;height: 80%;"></iframe>
      </div>
    </div>
    <!-- footer -->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
  import headerBar from '@/components/headerBar'
  import footerBar from '@/components/footerBar'
  import {getSurplusMoneyUrl} from '@/api/login'
  import {getAllOrder, getNewsList, getNoticeList} from '@/api/order'
  import VueQr from 'vue-qr';

  export default {
    components: {headerBar, footerBar, VueQr},
    data(){
      return{
        // 选中的当前导航
        selected: "",
        // 城市名称
        cityName: '',
        // 左侧菜单下标
        navCurrent: 0,
        // 嵌套iframe---我的卡包url
        myCardBagUrl: '',
        // 嵌套iframe---基本信息url
        webinfoUrl: '',
        // 订单列表-----
        dataList: [],
        // 订单分页
        pageNum: 1,
        pageSize: 15,
        total: 0,
        // 消息列表-----
        newsList: [],
        // 消息list当前下标
        newsCurrentIndex: 0,
        // 消息详情二维码对话框
        newsDialogVisible: false,
        // 消息分页
        newPageNum: 1,
        newPageSize: 15,
        newTotal: 0,
        // 公告列表-----
        noticeList: [],
        // 公告分页
        noticePageNum: 1,
        noticePageSize: 15,
        noticeTotal: 0,


      }
    },
    mounted() {
      //保证this实例已经插入文档
      this.$nextTick(function(){
        // 切换页面时滚动条自动滚动到顶部
        window.scrollTo(0,0);
        // 获取城市名称
        this.cityName = localStorage.getItem('cityName');
        // 获取个人中心
        this.getSurplusMoneyUrl();
      })
    },
    methods: {
      // 获取子组件（headerBar）传递的值
      getCityId(cityId){
        this.cityId = cityId;
        this.cityName = localStorage.getItem("cityName");
      },
      // 获取个人中心
      getSurplusMoneyUrl() {
        // let data = {};
        // getSurplusMoneyUrl(data).then(response => {
          let getTimestamp = new Date().getTime();
          this.myCardBagUrl = process.env.LOGIN_URL + "/webcardlist.html#/?getTimestamp" + getTimestamp;
          this.webinfoUrl = process.env.LOGIN_URL + "/webinfo.html#/?getTimestamp" + getTimestamp;
          this.getAllOrder();
        // });
      },
      // 菜单跳转
      goPage(val){
        this.navCurrent = val;
        if(val==2){//我的消息
          this.getNewsList();
        }else if(val==3){//我的公告
          this.getNoticeList();
        }
      },
      // 获取订单列表
      getAllOrder() {
      	let signdata = {page: this.pageNum};
        let data = {status: '0', page: this.pageNum, pageSize: this.pageSize, signdata: signdata};
        getAllOrder(data).then(response => {
          this.dataList = response.data;
          this.total = response.total;
        });
      },
      // 付款按钮--跳转到确认订单页面
      toConfirmOrder(orderId){
        this.$router.push({path: '/confirmOrder', query: {orderId: orderId}});
      },
      // 跳转到订单详情
      toOrderDetail(orderId) {
        this.$router.push({path: '/orderDetail', query: {orderId: orderId}})
      },
      // 获取消息列表
      getNewsList() {
        let signdata = {page: this.newPageNum};
        let data = {page: this.newPageNum, pageSize: this.newPageSize, signdata: signdata};
        getNewsList(data).then(response => {
          this.newsList = response.data;
          this.newTotal = response.total;
        });
      },
      // 消息--查看二维码
      toNewsDialog(index){
        this.newsCurrentIndex = index;
        this.newsDialogVisible = true;
      },
      // 获取公告列表
      getNoticeList() {
        let signdata = {page: this.noticePageNum};
        let data = {page: this.noticePageNum, pageSize: this.noticePageSize, signdata: signdata};
        getNoticeList(data).then(response => {
          this.noticeList = response.data;
          this.noticeTotal = response.total;
        });
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getAllOrder();
      },
      handleCurrentChange2(val) {
        this.newPageNum = val;
        this.getNewsList();
      },
      handleCurrentChange3(val) {
        this.noticePageNum = val;
        this.getNoticeList();
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    margin: 120px auto 30px auto;
    width: 75%;
    display: flex;
    border: 1px solid #e1e1e1;
  }
  .user-nav{
    width: 200px;
    background-color: #f4f3f4;
    text-align: center;
    border-right: 1px solid #e1e1e1;
  }
  .user-nav h1 {
    margin-top: 40px;
    margin-bottom: 30px;
    font-size: 22px;
    color: #222;
    font-weight: 400;
  }
  .user-nav .menu-item{
    display: block;
    font-weight: 400;
    color: #333;
    height: 40px;
    width: 202px;
    margin-left: -1px;
    line-height: 40px;
    font-size: 18px;
  }
  .user-nav .menu-item.active{
    background-color: #ed3931;
  }
  .user-nav .menu-item.active a{
    color: #fff;
  }
  .user-nav .menu-item:hover{
    cursor: pointer;
  }
  .main{
    flex: 1;
    padding-left: 40px;
    padding-bottom: 20px;
  }
  .title {
    margin-bottom: 30px;
    padding: 26px 0;
    font-size: 18px;
    color: #ec443f;
    border-bottom: 1px solid #e1e1e1;
    text-align: left;
  }
  .order-box {
    margin: 0 40px 30px 0;
    border: 1px solid #e5e5e5;
  }
  .order-box .order-header {
    padding: 16px 20px;
    font-size: 14px;
    background-color: #f7f7f7;
    text-align: left;
  }
  .order-box .order-header .order-date {
    color: #333;
    display: inline-block;
    margin-right: 30px;
  }
  .order-box .order-header .order-id {
    color: #999;
  }
  .order-box .order-header .del-order {
    width: 15px;
    height: 16px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAAAXNSR0IArs4c6QAAAP5JREFUKBVjZMACZs2alfTv3z95kNT///9FOTg4qhITEz+gK2UEKlQDKhBEklAG8ksZGRk3QDWzAPmhLCws0UADWWDqBAUFz7MABVKAAvYwQaBCVnZ2drekpKTXMLEZM2Y8/fv37wwg/x9M7MuXLz4wNnk00NTkmTNnppGiG6jnCEg9E9BvMkCnSsM0T58+/T8+NlAtE1DeCqQGxCAbjGomMegoDrAvwLgzglmamZnJiI89Z84cdaB6sBpgemeZ9evXrx5g4rgLTDALgRqZYZrRaaA8858/f6qBdCZIDmwCMHmyAjNIDpDPz8TEBE9h6JqBNv4Fih3PyMjYC5IDACkobU1JvS12AAAAAElFTkSuQmCC) no-repeat;
    float: right;
  }
  .order-box .order-body {
    display: flex;
    align-items: center;
    padding: 20px;
    padding-right: 0;
  }
  .order-box .order-body .poster {
    border: 2px solid #fff;
    -webkit-box-shadow: 0 1px 2px 0 hsla(0,0%,53%,.5);
    box-shadow: 0 1px 2px 0 hsla(0,0%,53%,.5);
    margin-right: 11px;
    font-size: 0;
  }
  .order-box .order-body .poster img {
    display: block;
    width: 66px;
    height: 91px;
  }
  .order-box .order-body .order-content {
    width: 49%;
    text-align: left;
  }
  .order-box .order-body .movie-name {
    font-size: 16px;
    font-weight: 700;
    color: #333;
    margin: 4px 0 7px -6px;
  }
  .order-box .order-body .cinema-name, .order-box .order-body .hall-ticket {
    font-size: 12px;
    color: #999;
    margin-bottom: 4px;
  }
  .order-box .order-body .cinema-name, .order-box .order-body .hall-ticket {
    font-size: 12px;
    color: #999;
    margin-bottom: 4px;
  }
  .order-box .order-body .hall-ticket span {
    display: inline-block;
    margin-right: 5px;
  }
  .order-box .order-body .show-time {
    font-size: 12px;
    color: #f03d37;
  }
  .order-box .order-body .actions, 
  .order-box .order-body .order-price, 
  .order-box .order-body .order-status {
    font-size: 14px;
    color: #333;
    width: 12%;
    line-height: 95px;
  }
  .order-box .order-body .order-status {
    width: 15%;
  }
  .order-box .order-body .actions{
    line-height: normal;
    display: inline-block;
    vertical-align: middle;
  }
  .order-box .order-body .actions .btn{
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 8px;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #f03d37;
    color: #fff;
    -webkit-box-shadow: 0 2px 10px -2px #f03d37;
    box-shadow: 0 2px 10px -2px #f03d37;
    border-radius: 15px;
    cursor: pointer;
  }
  .order-box .order-body .actions .link:hover{
    color: #ef4238;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/orderList.vue